export default function Loading() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 0',
      }}
    >
      <span
        style={{
          fontSize: 13,
          color: '#9a9a9a',
          letterSpacing: '0.15em',
        }}
      >
        加载中
      </span>
    </div>
  )
}
